import React from "react";
import styles from "./css/Section6.module.css";
import { AskQuestionEng } from "../../svg_groups/ask_question_eng";
import { AskQuestionRo } from "../../svg_groups/ask_question_ro";
import { MadeWithLove } from "../../svg_groups/made_with_love";
import { MadeWithLove_RO } from "../../svg_groups/made_with_love_ro";
import { useSelector } from "react-redux";
import FavoriteIcon from "@mui/icons-material/Favorite";
import consultation1 from "../../assets/mariana_pics/consultation1.png";

const Section6 = () => {
  const language = useSelector((state: any) => state.language.value);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.frameContainer}>
        <div className={styles.circleContainer}>
          {/* Circle with rotation */}
          {language === "EN" && <MadeWithLove />}
          {language === "RO" && <MadeWithLove_RO />}
        </div>
        {/* Heart outside the rotating container */}
        <div className={styles.heartIconWrapper}>
          <FavoriteIcon sx={{ fontSize: 40, color: "#C4B57C" }} />
        </div>
        <div className={styles.frame}>
          <img src={consultation1} alt="" />
        </div>

        <div className={styles.frame2}>
          <div className={styles.heading}>
            <div className={styles.spiritLiber}>
              <span className={styles.spiritLiber1}>
                {language === "EN" && "From Mariana, a Free Spirit, "}
                {language === "RO" && "De la Mariana, un Spirit Liber, "}
              </span>
              <span className={styles.pentruTine}>
                {language === "EN" && "for you"}
                {language === "RO" && "pentru tine"}
              </span>
            </div>
            <span className={styles.spiritLiberPentruTine}>
              {language === "EN" && "From Mariana, a Free Spirit, for you"}
              {language === "RO" &&
                "De la Mariana, un Spirit Liber, pentru tine"}
            </span>
          </div>
          <span className={styles.dreamerTransformPower}>
            {language === "EN" &&
              "I am a dreamer who has transformed pain into strength, fear into courage, and the desire to hide into the joy of showing myself to the world as I am. I believe in you, just as I have learned to believe in myself."}
            {language === "RO" &&
              "Eu sunt o visătoare care a transformat durerea în putere, frica în curaj și dorința de a mă ascunde în bucuria de a mă arăta lumii așa cum sunt. Cred în tine, așa cum am învățat să cred în mine."}
          </span>
          <span className={styles.discoverFreedom}>
            {language === "EN" &&
              "Together, we can discover the freedom that is rightfully yours. Today, be open to meeting people who will open new paths for you. Perhaps this moment is just the beginning of your journey."}
            {language === "RO" &&
              "Împreună, putem descoperi libertatea care îți aparține de drept. Astăzi, fii deschis/ă să întâlnești oamenii care îți vor deschide noi drumuri. Poate că acest moment este chiar începutul tău."}
          </span>
          <div className={styles.readyDiscoverInnerFreedom}>
            <span className={styles.text6}>
              {language === "EN" && "Are you ready? I invite you to discover "}
              {language === "RO" && "Ești gata? Te invit să-ți descoperi "}
            </span>
            <span className={styles.text7}>
              {language === "EN" && "your inner freedom!"}
              {language === "RO" && "libertatea interioară!"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section6;
